import React from 'react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { Stats } from '../components/Stats';
import { Values } from '../components/Values';
import { WhyMorvix } from '../components/WhyMorvix';
import { Process } from '../components/Process';
import { Marquee } from '../components/Marquee';
import { ConsultationCTA } from '../components/ConsultationCTA';
import { Newsletter } from '../components/Newsletter';
import { MaskText, Reveal, SectionLabel } from '../components/ui/Reveal';
import { brand, images } from '../data/site';
export function AboutPage() {
  return <>
      <Seo title="About — Creative Agency & Brand Identity Studio | Morvix Graphics" description="Morvix Graphics is a creative agency helping businesses communicate better through exceptional design. Founded by Moses, serving clients worldwide with 24-hour support." path="/about" data-id="element-627" data-mp="3iddg3nwkwkpw" />
      <PageHeader eyebrow="About" title="A studio built|to eradicate|bad design" lead={`${brand.name} is a creative agency focused on helping businesses communicate better through exceptional design and visual experiences. Founded by ${brand.founder}, operating under ${brand.parent}.`} meta={brand.serviceModel} data-id="element-628" data-mp="1bmf94fk59ocw" />

      {/* Story */}
      <section className="bg-surface2 py-20 sm:py-28" aria-label="Brand story" data-id="element-629" data-mp="2atuf7939dxd7">
        <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-630" data-mp="2yjonregjozrn">
          <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-start" data-id="element-631" data-mp="2ymkm33wb1qgm">
            <div data-id="element-632" data-mp="32l0ejnb5nr1f">
              <SectionLabel data-id="element-633" data-mp="32nmmvp5veakp">The story</SectionLabel>
              <h2 className="mt-5 max-w-2xl font-display text-3xl font-extrabold uppercase leading-[0.92] tracking-tightest sm:text-5xl" data-id="element-634" data-mp="2otlx3kwwbxwh">
                <MaskText text="Great products lose|to better presentation|every single day." data-id="element-635" data-mp="2tr5a6hhuy4mu" />
              </h2>
              <div className="mt-8 max-w-xl space-y-5 text-base leading-relaxed text-muted sm:text-lg" data-id="element-636" data-mp="3m9srrmxnb1j6">
                <p data-id="element-637" data-mp="3rdbt345rz">
                  Morvix Graphics started from a simple observation: plenty of businesses have strong
                  products, services and ideas — and no way to communicate their value visually.
                </p>
                <p data-id="element-638" data-mp="3m6aftt0b4vyd">
                  Poor design makes a capable business look weak, outdated or untrustworthy. We build
                  the other side of that equation: visual experiences that communicate clearly, build
                  credibility, create memorable impressions and make brands stand out.
                </p>
                <p data-id="element-639" data-mp="38e3yw4pbykxv">
                  That means we do more than “make graphics”. Creativity, visual communication,
                  strategy, branding, design thinking, innovation and business understanding all sit
                  in the same process.
                </p>
              </div>
            </div>

            <Reveal data-id="element-640" data-mp="2tkr0az8o9adl">
              <figure data-id="element-641" data-mp="2pgt0snffpxk0">
                <img src={images.process} alt="Design process — vector construction of a geometric monogram on screen" className="w-full object-cover" loading="lazy" decoding="async" data-id="element-642" data-mp="2pidxojp81sl1" />
                <figcaption className="label mt-3 text-muted" data-id="element-643" data-mp="1dzp2th7ja6hw">
                  Behind the scenes — mark construction
                </figcaption>
              </figure>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Mission & vision */}
      <section className="bg-surface py-20 sm:py-28" aria-label="Mission and vision" data-id="element-644" data-mp="qadxrnj5hpxy">
        <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-645" data-mp="q81iji4s1tol">
          <div className="grid border-t border-line lg:grid-cols-2" data-id="element-646" data-mp="v7wa7nwdmnap">
            <div className="border-b border-line py-10 lg:border-b-0 lg:pr-12" data-id="element-647" data-mp="100gyk9wik86u">
              <SectionLabel data-id="element-648" data-mp="2l32glkkknr7">Mission</SectionLabel>
              <p className="mt-6 font-display text-3xl font-extrabold uppercase leading-[0.95] tracking-tightest sm:text-[2.9rem]" data-id="element-649" data-mp="2ka4oa3l98l7">
                Eradicate bad design. Build visuals that sell. Make brands unforgettable.
              </p>
              <p className="mt-6 max-w-md text-sm leading-relaxed text-muted" data-id="element-650" data-mp="257grn0b8u48g">
                We take design somewhere more beautiful and more meaningful — work that converts and
                still deserves to be looked at.
              </p>
            </div>
            <div className="py-10 lg:border-l lg:border-line lg:pl-12" data-id="element-651" data-mp="2e6u5e56eheyz">
              <SectionLabel data-id="element-652" data-mp="2sw05dvd2b97x">Vision</SectionLabel>
              <p className="mt-6 font-serif text-3xl italic leading-tight sm:text-[2.6rem]" data-id="element-653" data-mp="2syw25gd6brus">
                To become one of the most recognised creative brands in the global online creative
                industry.
              </p>
              <p className="mt-6 max-w-md text-sm leading-relaxed text-muted" data-id="element-654" data-mp="2wyekq5hivqug">
                Remote by design, global by intention — working with brands across the US, UK,
                Europe, Asia and beyond.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Marquee items={['Creativity', 'Strategy', 'Craft', 'Clarity', 'Identity', 'Impact']} duration={40} data-id="element-655" data-mp="3e7gxicg0oyco" />

      <Stats data-id="element-656" data-mp="3j6k0zsgcmwij" />
      <Values data-id="element-657" data-mp="3j6a73ts6o57k" />

      {/* Philosophy */}
      <section className="bg-surface2 py-20 sm:py-28" aria-label="Creative philosophy" data-id="element-658" data-mp="35fx4m6y29ipm">
        <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-659" data-mp="39h8ri4pjvpu4">
          <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-660" data-mp="39f5uh0pzcwfw">
            <Reveal data-id="element-661" data-mp="2vfwh08t5sgfm">
              <img src={images.poster} alt="Abstract editorial composition built from Morvix brand shapes" className="w-full object-cover" loading="lazy" decoding="async" data-id="element-662" data-mp="2vjk70xzeakpl" />
            </Reveal>
            <div data-id="element-663" data-mp="2qio6mue95gox">
              <SectionLabel data-id="element-664" data-mp="2qk7m4is33npn">Creative philosophy</SectionLabel>
              <h2 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[0.92] tracking-tightest sm:text-5xl" data-id="element-665" data-mp="kpxwnxh0n9n0">
                <MaskText text="Design should|communicate,|differentiate|and persuade." data-id="element-666" data-mp="ooowwdgs37ec" />
              </h2>
              <p className="mt-7 max-w-xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-667" data-mp="1xllrt7ukjswb">
                Decoration is the easy part. We are interested in the harder question: what does this
                brand need people to understand, feel and remember — and what visual system delivers
                that consistently, everywhere?
              </p>
              <dl className="mt-9 grid gap-6 sm:grid-cols-2" data-id="element-668" data-mp="2gdy0sdfq9sff">
                <div className="border-t border-line pt-4" data-id="element-669" data-mp="2ccchoaclohws">
                  <dt className="label text-muted" data-id="element-670" data-mp="2ceyx0w5qg1pk">Founder</dt>
                  <dd className="mt-2 font-display text-xl font-bold uppercase" data-id="element-671" data-mp="27kur8g87dzq2">{brand.founder}</dd>
                </div>
                <div className="border-t border-line pt-4" data-id="element-672" data-mp="22msx9098ofzt">
                  <dt className="label text-muted" data-id="element-673" data-mp="302ovg1uj18va">Availability</dt>
                  <dd className="mt-2 font-display text-xl font-bold uppercase" data-id="element-674" data-mp="2vbqed01ps6qz">24 / 7</dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </section>

      <WhyMorvix data-id="element-675" data-mp="32p7t1jy9gy4q" />
      <Process data-id="element-676" data-mp="37lpry36wu295" />
      <ConsultationCTA data-id="element-677" data-mp="37l6b6pszxjwp" />
      <Newsletter data-id="element-678" data-mp="37mr8gn6p3gy9" />
    </>;
}